import { render } from "./Recommendation.vue?vue&type=template&id=40f91b74&ts=true"
import script from "./Recommendation.vue?vue&type=script&lang=ts"
export * from "./Recommendation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__